import io from "socket.io-client";

const URL_IEX_SOCKET = "https://ws-api.iextrading.com/1.0/tops";

let _symbol = "";
let _onReceive = null;
let _socket = null;

if (_socket) {
  _socket.on("message", (data) => {
    const quote = JSON.parse(data);

    _onReceive &&
      _onReceive({
        symbol: quote.symbol,
        ask: quote.askPrice,
        bid: quote.bidPrice,
        last: quote.lastSalePrice,
      });
  });
}

export const wsOnReceive = (callback) => {
  _onReceive = callback;
};

export const wsSubscribeSymbol = (symbol) => {
  if (!_socket) _socket = io(URL_IEX_SOCKET, { reconnection: false });
  if (_symbol) {
    _socket.emit("unsubscribe", _symbol);
  }

  _symbol = symbol;
  _socket.emit("subscribe", _symbol);
};

export const wsUnsuscribeSymbol = (symbol) => {
  if (!_socket) _socket = io(URL_IEX_SOCKET, { reconnection: false });
  _socket.emit("unsubscribe", _symbol);
  _symbol = "";
};
